module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./VideoPlayerView.js"));
	}, "VideoPlayerView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=VideoPlayerView!./src/pages/Promote/OfflineActivity/ActivityPicture/UploadPicture/VideoPlayerView.js
// module id = 1164
// module chunks = 438